<template>
  <div class="warp_contrainer">
    <div class="search_container">
      <el-tabs
        v-model="activeName"
        type="card"
        @tab-click="handleClick(activeName)"
      >
        <el-tab-pane label="所有" name="1"> </el-tab-pane>
        <el-tab-pane label="待处理" name="2"></el-tab-pane>
        <el-tab-pane label="处理中" name="3"></el-tab-pane>
        <el-tab-pane label="已处理" name="4"></el-tab-pane>
      </el-tabs>
      <div class="navCalss">| 派送列表</div>
      <!-- 订单查询 -->
      <div class="search">
        <span
          >发货单号:
          <el-input
            placeholder="输入运单号/订单编号查询"
            clearable
            @clear="getDeliveryList"
            v-model="orderNo"
          ></el-input
        ></span>
        <span
          >用户名/ViP号:
          <el-input
            placeholder="输入用户名/vip号查询"
            clearable
            @clear="getDeliveryList"
            v-model="userName"
          ></el-input
        ></span>
        <span
          >派送编号:
          <el-input
            placeholder="请输入派送编号"
            clearable
            @clear="getDeliveryList"
            v-model="deliveryNumber"
          ></el-input>
        </span>
        <span
          >批次:
          <el-select
            v-model="deliveryBatch"
            style="width: 255px;padding-right:6px"
            remote
            @change="batchChange"
            @clear="clearChecked"
            :remote-method="remoteMethod"
            reserve-keyword
            filterable
            :loading="loading"
            clearable
            placeholder="请输入批次"
          >
            <el-option
              v-for="item in batchList"
              :key="item.sendId"
              :label="item.remark"
              :value="item.remark"
            >
            </el-option>
          </el-select>
        </span>

        <span>签收状态：</span>
        <el-select
          v-model="checkedRecStatus"
          clearable
          @change="getDeliveryList()"
          placeholder="请选择"
          style="width: 120px"
        >
          <el-option
            v-for="item in receOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>

        <span
          ><el-button
            type="primary"
            style="margin-left: 20px; width: 100px"
            @click="getDeliveryList('select')"
            >查 询</el-button
          ></span
        >
        <span
          ><el-button
            type="primary"
            style="margin-left: 20px; width: 100px"
            @click="exportToExcel()"
            >导出</el-button
          ></span
        >
      </div>
      <!-- 表格区域 -->
      <el-table
        :data="mainList"
        border
        max-height="550px"
        @selection-change="handleSelectionChange"
        style="width: 100%"
      >
        <el-table-column type="selection" width="35" align="center">
        </el-table-column>
        <el-table-column
          prop="deliveryNumber"
          label="派送编号"
          align="center"
          width="100px"
        >
        </el-table-column>
        <el-table-column prop="price" label="运单" align="center">
          <template slot-scope="scope">
            {{ scope.row.orderCount }} 个运单
          </template>
        </el-table-column>
        <el-table-column prop="realName" label="客户" align="center">
        </el-table-column>
        <el-table-column prop="vipCode" label="vip号" align="center">
        </el-table-column>
        <el-table-column label="货物类型" align="center">
          <template slot-scope="scope">
            <span>
              <span class="tag" v-if="scope.row.goodType == 1">{{
                goodTypeName(scope.row.goodType)
              }}</span>
              <span class="tag tag3" v-if="scope.row.goodType == 2">{{
                goodTypeName(scope.row.goodType)
              }}</span>
              <span class="tag tag1" v-if="scope.row.goodType == 3">{{
                goodTypeName(scope.row.goodType)
              }}</span>
              {{ scope.row.goodName }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="sendNo"
          label="发货单号"
          align="center"
          width="140px"
        >
        </el-table-column>
        <el-table-column
          prop="sendRemark"
          label="批次"
          align="center"
          width="140px"
        >
        </el-table-column>
        <el-table-column
          label="箱号"
          prop="boxNumber"
          min-width="180px"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="address" label="状态" align="center">
          <template slot-scope="scope">
            <div class="status_text">
              <div v-if="scope.row.status == 2" style="color: #1e90ff">
                已处理
              </div>
              <div v-else-if="scope.row.status == 0">
                <div style="color: #d9001b">待处理</div>
              </div>
              <div v-else-if="scope.row.status == 1">
                <div style="color: #ffd700">处理中</div>
              </div>
              <div v-else-if="scope.row.status == -1">
                <div style="color: #ff6347">已取消</div>
              </div>
              <div v-else-if="scope.row.status == 3">
                <div style="color: #ff6347">已取消</div>
              </div>
            </div>
          </template>
        </el-table-column>

        <el-table-column prop="price" label="派送费" align="center">
        </el-table-column>
        <el-table-column prop="amount" width="120px" label="发货单总费用" align="center">
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="提出时间"
          align="center"
          width="160px"
        >
          <template slot-scope="scope">
            {{ changeDate(scope.row, 1) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="volume"
          label="体积CBM"
          align="center"
          width="100px"
        >
        </el-table-column>

        <el-table-column prop="productWeight" label="重量KG" align="center">
        </el-table-column>

        <el-table-column prop="unMixingTank" label="箱数" align="center">
        </el-table-column>

        <el-table-column prop="mixingTank" label="混箱数" align="center">
        </el-table-column>

        <el-table-column
          prop="mobile"
          label="收货人电话"
          width="100px"
          align="center"
        >
        </el-table-column>

        <el-table-column prop="address" label="收货地址" align="center">
        </el-table-column>

        <el-table-column
          label="签收状态"
          prop="isReceipt"
          min-width="90px"
          align="center"
        >
          <template slot-scope="scope">
            {{ scope.row.isReceipt ? "已签收" : "未签收" }}
          </template>
        </el-table-column>

        <el-table-column
          label="预计派送时间"
          prop="expectTime"
          min-width="160px"
          align="center"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.expectTime">{{
              changeToTime(scope.row.expectTime)
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          fixed="right"
          label="操作"
          align="center"
          width="200px"
        >
          <template slot-scope="scope">
            <el-button type="text" class="bt" @click="showEditDia(scope.row)"
              >查看</el-button
            >
            <el-button
              class="bt"
              @click="showAccountDia(scope.row)"
              type="text"
              v-if="scope.row.status == 2"
              >出库结算</el-button
            >
            <el-button class="bt2" @click="showOrder(scope.row)" type="text"
              >订单详情</el-button
            >
            <el-button class="bt2" @click="onLook(scope.row)" type="text"
              >发货单详情</el-button
            >
            <el-button class="bt2" @click="updateAddress(scope.row)" type="text"
              >地址修改</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="footer">
        <div v-if="activeName == 4">
          <el-button type="primary" size="small" @click="mulOutStoreToPay()"
            >批量出库结算</el-button
          >
        </div>
        <div class="footer_pagination">
          <el-pagination
            :page-sizes="paginations.page_sizes"
            :page-size="paginations.page_size"
            :layout="paginations.layout"
            :total="paginations.total"
            :current-page="paginations.page_index"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <!-- <div v-if="activeName == 4">
        <el-button type="primary" size="small" @click="mulOutStoreToPay()">批量出库结算</el-button>
      </div> -->
    <!-- 查看Dialog -->
    <el-dialog
      title="编 辑"
      :visible.sync="editDialog"
      width="60%"
      center
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
    >
      <div v-for="(item, index) of editLsit" :key="index">
        <div class="diaBox">
          <div class="dialog_left diaBoxIn">
            <div class="dialog_left_top diaStyle">
              <div class="dialog_left_top1" style="margin-bottom: 15px">
                发货单号：{{ item.sendNo }}
              </div>
              <div class="dialog_left_top2">
                提交时间：{{
                  item.createTime ? changeDate(item, 1) : "时间未知"
                }}
              </div>
            </div>

            <div style="border-top: 2px solid black" class="dialog_left_center diaStyle">
              <p style="margin-bottom: 15px">客户名称：{{ item.userName }}</p>
              <p style="margin-bottom: 15px">贵宾号：{{ item.vipCode }}</p>
              <p style="margin-bottom: 15px">总运费：CAD {{ item.amount }}</p>
              <p style="margin-bottom: 15px">备注： 未含加拿大出库后的派送费用</p>
              <p>客户需求： <span>派送</span></p>
            </div>

            <div style="border-top: 2px solid black" class="dialog_left_center diaStyle">
              <div class="dialog_left_top2">派送地址：{{ item.address }}</div>
              <div class="dialog_left_top2">派送电话：{{ item.mobile }}</div>
              <div class="dialog_left_top2">
                <span>总体积：{{ item.volume }}</span>
                <span class="rightSpan">总重量：{{ item.productWeight }}</span>
              </div>
              <div class="dialog_left_top2">
                <span>特混箱数：{{ item.mixingTank }}</span>
                <span class="rightSpan">箱数：{{ item.unMixingTank }}</span>
              </div>
            </div>

            <div style="border-top:solid" class="diaStyle">
              <div style="margin-bottom: 15px">
                订单状态：
                <el-select
                  v-model="status.statusType"
                  clearable
                  placeholder="订单状态"
                  @change="init()"
                  size="small"
                  style="width: 150px"
                  :disabled="isDisabledStatus==2"
                >
                  <el-option
                    v-for="item in statusTypeSelect"
                    :key="item.statusType"
                    :label="item.statusName"
                    :value="item.statusType"
                  >
                  </el-option>
                </el-select>
              </div>

              <div style="margin: 0 0 15px -26px">
                <el-form
                  :model="ruleForm"
                  :rules="rules"
                  ref="RuleForm"
                  label-width="100px"
                  label-position="right"
                  class="demo-ruleForm"
                >
                  <el-form-item label="派送费用 :" prop="price">
                    <el-input
                      v-model="ruleForm.price"
                      type="number"
                      clearable
                      size="small"
                      style="width: 150px"
                      :disabled="isDisabledStatus==2"
                    ></el-input>
                  </el-form-item>
                </el-form>
              </div>

              <div style="margin-bottom: 15px">
                预计派送时间：<el-date-picker
                  v-model="expectTime"
                  type="datetime"
                  size="small"
                  style="width: 140px"
                  :picker-options="pickerOptions"
                  placeholder="选择派送时间"
                  :disabled="isDisabledStatus==2"
                >
                </el-date-picker>
              </div>

              <div style="margin-bottom: 15px">
                余额：CAD
                <span style="color: #ffa500">
                  {{ item.balance }}
                </span>
              </div>
              <div style="margin-bottom: 15px">
                备注：
                <div style="margin-top: 6px">1. 加拿大出库后的派送上门费用</div>
                <div style="margin-top: 6px">
                  2. 派送状态为已处理时派送费用才有效
                </div>
              </div>
              <div style="text-align: center;margin:36px 0 0 0">
                <el-button :disabled="isDisabledStatus==2" type="primary" @click="updateDelivery">
                  提 交
                </el-button>
              </div>
            </div>
          </div>
          <div class="dialog_right diaBoxIn">
            <div
              class="dialog_right_text"
              style="text-align: center; border-bottom: 2px solid black"
            >
              反馈记录
            </div>
            <div class="dia_Text">
              <div class="dia_Text_content">
                <div
                  class="content_text"
                  v-for="(item, index) of feedbackList"
                  :key="index"
                >
                  <div v-if="item.type == 1" style="">
                    <div>
                      <span style="font-size: 12px">
                        {{ changeDate(item.operatorTime, 4) }}
                      </span>
                    </div>
                    <span>
                      <el-avatar
                        size="medium"
                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                      ></el-avatar>
                    </span>
                    <span style="display: block;margin:-30px 0 0 43px">
                      {{ item.content }}
                    </span>
                  </div>
                  <div v-if="item.type == 2" style="position: relative;text-align: right">
                    <div>
                      <span style="font-size: 12px">
                        {{ changeDate(item.operatorTime, 4) }}
                      </span>
                    </div>
                    <span style="position: absolute;right: 40px;top: 28px;">
                      {{ item.content }}
                    </span>
                    <span>
                      <el-avatar
                        size="medium"
                        src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png"
                      ></el-avatar>
                    </span>
                  </div>
                </div>
              </div>
              <div class="dia_Text_input">
                <el-button
                  type="text"
                  class="refresh el-icon-refresh-right"
                  @click="getFeedbackList(1)"
                >
                </el-button>
                <el-input
                  class="dinput"
                  id="diaBt"
                  @keyup.native.13="postDeliveryFeedback"
                  v-model="content"
                  clearable
                >
                </el-input>
                <el-button
                  type="primary"
                  class="dbt"
                  @click="postDeliveryFeedback"
                ><span class="send">发 送</span>
                </el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 出库结算Dialog -->
    <el-dialog
      title="出库结算"
      :visible.sync="accountDia"
      width="60%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
    >
      <!-- 中间文字内容 -->
      <div v-for="(item, index) of accountList" :key="index" class="BigBox">
        <div class="accountDia-content-header">
          <div class="content-left content-left-text">
            <div>
              发货单号:
              <span>
                {{ item.sendNo }}
              </span>
            </div>
            <div>
              预约状态:
              <span style="color: rgb(9, 157, 255)"> 已预约 </span>
            </div>
          </div>
          <div class="content-center content-left-text">
            <div>
              VIP号:
              <span>
                {{ item.user.vipCode }}
              </span>
            </div>
            <div>
              入库时间:
              <span>
                {{
                  item.operatorTime
                    ? changeDate(item.operatorTime, 4)
                    : "无法显示"
                }}
              </span>
            </div>
          </div>
          <div class="content-right content-left-text">
            <div>
              客户:
              <span>
                {{ item.user.realName }}
              </span>
            </div>
            <div>
              订单数量: <span>{{ item.orderPojoList.length }}</span>
            </div>
          </div>
        </div>
        <div class="accountDia-content-center1" style="margin-bottom: 10px">
          <div
            class="content-footer-left"
            style="width: 36%; float: left; margin-right: 20px"
          >
            所需总运费：<span>{{ item.totalFreight }}</span>
          </div>
          <div class="content-footer-right" style="width: 36%; float: left">
            所需总派送费：<span>{{ item.deliveryPrice }}</span>
          </div>
        </div>
        <div class="accountDia-content-center2" style="margin-bottom: 15px">
          所需总工单费用：<span>{{ item.totalWorkOrderFee }}</span>
        </div>
        <div
          class="accountDia-content-footer1"
          style="width: 100%; overflow: hidden"
        >
          <div
            class="content-footer-left"
            style="width: 32%; float: left; margin-right: 6px"
          >
            额外费用：<span>{{ item.extraPrice }}</span> CAD
          </div>
          <div
            class="content-footer-left"
            style="width: 32%; float: left; margin-right: 6px"
          >
            最后总费用：<span>{{ item.totalCost }}</span> CAD
          </div>
          <div class="content-footer-right" style="width: 32%; float: left">
            账户余额：
            <span style="color: #d2691e">{{ item.user.balance }}</span> CAD
          </div>
        </div>
        <div
          class="accountDia-content-footer2"
          style="width: 100%; margin-top: 30px; text-align: center"
        >
          <span style="width: 46%; font-size: 17px; font-weight: bolder">
            订单列表
          </span>
        </div>
        <hr style="margin: 25px 0 -20px 0" />
        <div class="table">
          <el-table :data="listRow" style="width: 100%">
            <el-table-column type="index" label="#" align="center">
            </el-table-column>
            <el-table-column prop="productName" align="center" label="物品">
            </el-table-column>
            <el-table-column prop="orderNo" label="运单号" align="center">
            </el-table-column>
            <el-table-column prop="productNum" align="center" label="数量">
            </el-table-column>
            <el-table-column align="center" label="货运类型">
              <template slot-scope="scope">
                {{ goodTypeName(scope.row.goodType) }}
              </template>
            </el-table-column>
            <el-table-column prop="goodType" align="center" label="用户">
              <div>
                {{ accountList[0].user.realName }}
              </div>
            </el-table-column>
            <el-table-column prop="total" align="center" label="运费（CAD）">
            </el-table-column>
            <el-table-column
              prop="demandMoney"
              align="center"
              label="工费（CAD）"
            >
            </el-table-column>
          </el-table>
        </div>
        <!-- 按钮区域 -->
        <div class="accountDia-footer">
          <el-button type="primary" @click="settlementBt()">确认结算</el-button>
          <el-button type="info" @click="accountDia = false">取 消</el-button>
        </div>
      </div>
    </el-dialog>
    <!-- 查看订单详情Dialog -->
    <el-dialog
      :visible.sync="listDia"
      width="70%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      center
    >
      <div class="diaText">
        <div class="e_text">发货单号：{{ orderMsg.sendNo }}</div>
        <div class="e_text">订单数量：{{ orderMsg.orderCount }}</div>
        <div class="e_text">相关用户VIP：{{ user.vipCode }}</div>
      </div>
      <div>
        <el-table :data="orderList" max-height="300px" style="width: 100%">
          <el-table-column
            prop="productName"
            label="名称"
            align="center"
            width="140"
          >
          </el-table-column>
          <el-table-column align="center" label="货物类型" width="140">
            <template slot-scope="scope">
              {{ goodTypeName(scope.row.goodType) }}
            </template>
          </el-table-column>
          <el-table-column label="客户" align="center" width="120">
            {{ user.realName }}
          </el-table-column>
          <el-table-column label="vip号" align="center" width="120">
            {{ user.vipCode }}
          </el-table-column>
          <el-table-column
            prop="expressNo"
            label="运单号"
            align="center"
            width="150"
          >
          </el-table-column>
          <el-table-column
            prop="predictTotal"
            label="商品价格"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column label="状态" align="center" width="120">
            <span style="color: rgb(9, 157, 255)"> 已预约 </span>
          </el-table-column>
          <el-table-column label="派送点" align="center" width="180">
            {{ user.deliveryTitle }}
          </el-table-column>
          <el-table-column
            prop="total"
            label="运费(CAD)"
            align="center"
            width="120"
          >
          </el-table-column>
          <el-table-column label="下单时间" align="center" width="240px">
            <template slot-scope="scope">
              {{ changeDate(scope.row.storeTime, 4) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
      <template #footer>
        <span class="warningDia-footer">
          <el-button type="primary" @click="listDia = false">确 定</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- //查看发货单详情 -->
    <el-dialog
      :visible.sync="dialog.show"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="1100px"
      center
    >
      <div style="position: relative">
        <el-table
          :show-header="false"
          :data="tableData"
          border
          style="width: 100%"
          stripe
        >
          <el-table-column
            prop="index"
            label="序号"
            align="center"
            min-width="100px"
          >
          </el-table-column>
          <el-table-column
            label="订单名"
            prop="productName"
            min-width="150px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="运单号"
            prop="expressNo"
            min-width="160px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="体积 CBM"
            prop="productSize"
            min-width="90px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="重量 KG"
            prop="productWeight"
            min-width="80px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="折扣率 %"
            prop="rate"
            min-width="80px"
            align="center"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.rate !== true">{{ scope.row.rate }}</span>
              <!-- <el-button type="text" v-if="scope.row.rate==true">修改</el-button> -->
            </template>
          </el-table-column>
          <el-table-column
            label="费用 CAD"
            prop="predictTotal"
            min-width="120px"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="订单备注"
            prop="remark"
            width="220px"
            align="center"
          >
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="isUpdateFeeShow"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="30%"
    >
      <div style="margin-top: -30px">
        <h1 style="float: left; font-size: 18px">额外费用 :</h1>
        <el-input
          v-model="feeInput"
          placeholder="请输入修改后的费用"
          autofocus
          style="float: left; width: 200px; margin: -8px 0 20px 20px"
        ></el-input>
        <h1
          style="
            clear: both;
            float: left;
            padding-bottom: 10px;
            font-size: 18px;
          "
        >
          备注 :
        </h1>
        <el-input
          type="textarea"
          placeholder="请输入额外费用备注"
          v-model="textarea"
          maxlength="300"
          show-word-limit
          clearable
          resize="none"
          rows="8"
        >
        </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeUpdateDialog">取 消</el-button>
        <el-button type="primary" @click="certainUpdateDialog">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title=""
      :visible.sync="dialog.updaAddDia"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      width="30%"
    >
      <div style="margin-top: -30px">
        <h1 style="float: left; font-size: 18px">收货人电话 :</h1>
        <el-input
          v-model="phone"
          placeholder="请输入收货人电话"
          autofocus
          style="float: left; width: 200px; margin: -8px 0 20px 20px"
        ></el-input>
        <h1
          style="
            clear: both;
            float: left;
            padding-bottom: 10px;
            font-size: 18px;
          "
        >
          收货人地址 :
        </h1>
        <el-input
          type="textarea"
          placeholder="请输入收货人地址"
          v-model="address"
          maxlength="300"
          show-word-limit
          clearable
          resize="none"
          rows="8"
        >
        </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="closeUpdaAddDialog">取 消</el-button>
        <el-button type="primary" @click="certainUpdaAddDialog"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>


<script>
import * as book from "../../api/book";
import * as order from "@/api/order";
import * as mUtils from "../../utils/mUtils";
export default {
  data() {
    return {
      activeName: "1",
      orderNo: "",
      userName: "",
      deliveryNumber: "",
      deliveryBatch: null,
      checkedStatus: "",
      sendId: "",
      deliveryId: "",
      editDialog: false,
      accountDia: false,
      warningDia: false,
      deliverList: [],
      feedbackList: [],
      content: "",
      listRow: [],
      orderMsg: [],
      user: [],
      mainList: [],
      listDia: false,
      overdueDlist: [],
      disposeList: [],
      disposingList: [],
      disposedList: [],
      cancelList: [],
      editLsit: [],
      orderList: [],
      sendNo: "",
      accountList: [],
      ruleForm: {
        price: "",
      },
      rules: {
        price: [{ required: true, message: "请输入派送费用", trigger: "blur" }],
      },
      search: {
        goodType: null,
      },
      goodTypeSelect: [
        {
          goodType: 1,
          goodName: "海运",
        },
        {
          goodType: 2,
          goodName: "海运大件",
        },
        {
          goodType: 3,
          goodName: "空运",
        },
      ],
      status: {
        statusType: null,
      },
      statusTypeSelect: [
        {
          statusType: 0,
          statusName: "待处理",
        },
        {
          statusType: 1,
          statusName: "处理中",
        },
        {
          statusType: 2,
          statusName: "已处理",
        },
        {
          statusType: -1,
          statusName: "已取消",
        },
      ],

      howManyTotal: 0,
      listArr: [],
      columnsOrder: [
        { title: "派送编号", key: "deliveryNumber" },
        { title: "运单", key: "orderCount" },
        { title: "客户", key: "realName" },
        { title: "vip号", key: "vipCode" },
        { title: "货物类型", key: "goodType" },
        { title: "发货单号", key: "sendNo" },
        { title: "批次", key: "sendRemark" },
        { title: "箱号", key: "boxNumber" },
        { title: "状态", key: "status" },
        { title: "总运费", key: "amount" },
        { title: "提出时间", key: "createTime" },
        { title: "体积CBM", key: "volume" },
        { title: "重量KG", key: "productWeight" },
        { title: "箱数", key: "unMixingTank" },
        { title: "混箱数", key: "mixingTank" },
        { title: "收货人电话", key: "mobile" },
        { title: "收货地址", key: "address" },
      ],

      lookWhichRow: null,
      dialog: {
        show: false,
        updaAddDia: false,
      },
      tableData: [
        {
          remark: "sdad",
          predictTotal: "100",
          rate: 10,
          productWeight: 12,
        },
      ],

      isUpdateFeeShow: false,
      feeInput: "",
      textarea: "",

      paramSendId: "",
      lookWhichRow: null,

      paramDeliverId: "",
      phone: "",
      address: "",
      paramSendNo: "",
      paramStatus: "",
      paramUserId: "",
      mobileText: "",
      addressText: "",

      //需要给分页组件传的信息
      paginations: {
        page_index: 1, // 当前位于哪页
        total: 0, // 总数
        page_size: 10, // 1页显示多少条
        page_sizes: [5, 10, 20, 100], //每页显示多少条
        layout: "total, sizes, prev, pager, next, jumper", // 翻页属性
      },

      multipleSelection: [],
      // 批次列表
      batchList: [],
      // 批次的时间 节流
      timeout: null,
      // 已选签收状态
      checkedRecStatus: null,
      // 签收状态选项
      receOptions: [
        { value: "0", label: "未签收" },
        { value: "1", label: "已签收" },
      ],
      loading: false,
      // 期望派送时间
      expectTime: "",
      //禁用今天以前的时间
      //data中定义
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 3600 * 1000 * 24;
        },
      },

      // 是否禁用表单 已处理状态下不可以修改信息
      isDisabledStatus:"",
    };
  },
  created() {
    this.getDeliveryList();
    this.getBatchList();
    // this.postDeliveryFeedback()
  },
  methods: {
    init() {},
    handleClick(res) {
      let that = this;
      this.mainList = [];
      if (res == "1") {
        this.mainList = this.overdueDlist;
        that.checkedStatus = "";
      } else if (res == "2") {
        this.mainList = this.disposeList;
        that.checkedStatus = "0";
      } else if (res == "3") {
        this.mainList = this.disposingList;
        that.checkedStatus = "1";
      } else if (res == "4") {
        this.mainList = this.disposedList;
        that.checkedStatus = "2";
      }

      this.res = res;
      this.getDeliveryList("select");
    },
    getDeliveryList(isSelect) {
      if (this.res == undefined || this.res == "" || this.res == "1") {
        this.activeName = "1";
      } else if (this.res == "2") {
        this.activeName = "2";
      } else if (this.res == "3") {
        this.activeName = "3";
      } else {
        this.activeName = "4";
      }
      let param = {
        pageIndex: this.paginations.page_index,
        pageSize: this.paginations.page_size,
        orderNo: this.orderNo ? this.orderNo : "",
        userName: this.userName ? this.userName : "",
        deliveryNumber: this.deliveryNumber ? this.deliveryNumber : "",
        status: this.checkedStatus ? this.checkedStatus : "",
        batchNumber: this.deliveryBatch ? this.deliveryBatch.trim() : null,
        isReceipt: this.checkedRecStatus || null,
      };

      if (isSelect == "select") {
        param.pageIndex = 1;
        this.paginations.page_index = 1;
      }

      this.mainList = [];
      this.disposeList = [];
      this.disposingList = [];
      this.disposedList = [];
      this.cancelList = [];
      book.getDeliveryList(param).then((res) => {
        if (res.status !== 200)
          return this.$message.error("获取派送列表失败: " + res.msg);
        if (res.data.code !== 0) {
          return this.$message.error("获取派送列表失败: " + res.msg);
        }
        this.deliverList = res.data.data.list;
        this.paginations.total = res.data.data.pageCount;
        this.howManyTotal = res.data.data.pageCount;
        this.mainList = this.deliverList;
        this.deliverData();
      });
    },
    deliverData() {
      this.overdueDlist = [];
      if (this.mainList == undefined) return;
      for (var i = 0; i < this.mainList.length; i++) {
        // if(this.mainList[i].status!==-1&&this.mainList[i].sendStatus!==4){
        //   this.overdueDlist[this.overdueDlist.length]=this.mainList[i]
        // }else{
        //   // this.overdueList[this.overdueList.length]=this.mainList[i]
        // }

        this.overdueDlist.push(this.mainList[i]);
      }

      this.mainList = this.overdueDlist;
      this.partList();
    },
    // 更新派送信息
    updateDelivery() {
      console.log(1141,typeof(this.expectTime));
      console.log(1144,this.expectTime);
      let param = {
        deliveryId: this.deliveryId ? this.deliveryId : "",
        status: this.status.statusType ? this.status.statusType : 0,
        price: this.ruleForm.price,
      };

      if(typeof(this.expectTime) == "number"){
        param.expectTime = this.expectTime;
      }else if(typeof(this.expectTime) == "object"){
        param.expectTime = new Date(mUtils.formatDate(this.expectTime)).getTime();
      }else{
        param.expectTime = "";
      }
      let boolean = "";
      this.$refs.RuleForm[0].validate((vali) => {
        boolean = vali;
      });
      if (boolean) {
        book.updateDelivery(param).then((res) => {
          if (res.status !== 200)
            return this.$message.error("更新派送列表失败: " + res.msg);
          if (res.data.code !== 0) {
            {
              return this.$message.error("更新派送列表失败: " + res.msg);
            }
          }
          this.$message.success("更新派送列表成功");
          this.expectTime = "";
          this.getDeliveryList();
        });
        this.editDialog = false;
      }
    },
    changeToTime(datetimes) {
      let date = new Date(datetimes);
      let Y = date.getFullYear() + "-";
      let M =
        (date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1) + "-";
      let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate() + " ";
      let h =
        date.getHours() < 10
          ? "0" + date.getHours() + ":"
          : date.getHours() + ":";
      let m =
        date.getMinutes() < 10
          ? "0" + date.getMinutes() + ":"
          : date.getMinutes() + ":";
      let s =
        date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();

      var str = Y + M + D + " " + h + m + s;
      return str;
    },
    // 获取消息列表
    getFeedbackList(type) {
      let param = {
        sendNo: this.sendNo,
      };
      this.feedbackList = [];
      book.getFeedbackList(param).then((res) => {
        if (res.status !== 200)
          return this.$message.error("获取消息列表失败: " + res.msg);
        if (res.data.code !== 0) {
          {
            return this.$message.error("获取消息列表失败: " + res.msg);
          }
        }
        this.feedbackList = res.data.data.list;
        if (type == 1) this.$message.success("刷新消息成功");
      });
    },
    //  发送反馈信息
    postDeliveryFeedback() {
      let param = {
        deliveryId: this.deliveryId,
        content: this.content,
      };
      if (this.content == "") return this.$message.error("请输入内容");
      book.postDeliveryFeedback(param).then(async (res) => {
        if (res.status !== 200)
          return this.$message.error("发送反馈消息列表失败: " + res.msg);
        if (res.data.code !== 0) {
          return this.$message.error("发送反馈消息列表失败: " + res.msg);
        }
        await this.getFeedbackList();
        this.content = "";
        this.$message.success("发送反馈消息成功");
      });
    },
    // 展示订单详情页面
    showOrder(row) {
      let param = {
        sendId: row.sendId,
      };
      book.getSettlementSheet(param).then((res) => {
        if (res.status == 200) {
          if (res.data.code !== 0) {
            this.$message.error("获取订单详情失败：" + res.data.msg);
            return;
          } else if (res.data.data == {}) {
            return this.$message.error("获取订单详情失败: 无出库面单数据");
          }
          this.orderMsg = res.data.data !== {} ? res.data.data : [];
          this.orderList = this.orderMsg.orderPojoList
            ? this.orderMsg.orderPojoList
            : [];
          this.user = this.orderMsg.user ? this.orderMsg.user : [];
          this.listDia = true;
        }
      });
    },

    //查看发货单详情
    onLook(val) {
      let that = this;
      that.dialog.show = true;
      that.lookWhichRow = val;
      that.getPreviewOrders(val);
    },

    updateAddress(val) {
      let that = this;
      that.dialog.updaAddDia = true;
      that.paramDeliverId = val.deliveryId;
      that.paramSendNo = val.sendNo;
      that.paramStatus = val.status;
      that.paramUserId = val.userId;
      let params = {
        sendNo: that.paramSendNo,
        userId: that.paramUserId,
      };

      order.getFeedbackList(params).then((res) => {
        if (res.data.code !== 0) return;
        if (res.data.data) {
          that.phone = that.mobileText = res.data.data.mobile;
          that.address = that.addressText = res.data.data.address;
        }
      });
    },

    closeUpdaAddDialog() {
      let that = this;
      that.dialog.updaAddDia = false;
      that.phone = "";
      that.address = "";
    },

    certainUpdaAddDialog() {
      let that = this;

      if (!that.phone || !that.address) {
        that.$message.warning("电话或者地址不能为空");
        return;
      }

      let param = {
        deliveryId: that.paramDeliverId,
        mobile: that.phone,
        address: that.address,
        status: that.paramStatus,
      };
      order.updateDelivery(param).then((res) => {
        if (res.data.code === 0) {
          that.$message.success("修改成功");
        } else {
          that.$message.error("修改失败");
        }
        that.dialog.updaAddDia = false;
        that.phone = "";
        that.address = "";
      });
    },

    //获取发货单详情
    getPreviewOrders(val) {
      let that = this;

      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      setTimeout(function () {
        loading.close();
      }, 5000);

      let data = {
        sendId: val.sendId,
        userId: val.userId,
      };
      let standard = 0,
        countTotal = 0,
        orderName = "";

      // order.sendSerOrders(data).then((res) => {

      order.getSendOrderInfo(data).then((res) => {
        loading.close();

        if (res.data.code == 0) {
          if (res.data.data.list.length) {
            that.volumeTotal = 0;
            that.weightTotal = 0;
            res.data.data.list.forEach(function (value, i) {
              value.index = i + 1;
              that.volumeTotal = value.productSize - 0 + that.volumeTotal;
              that.weightTotal = value.productWeight - 0 + that.weightTotal;
              value.detailList.forEach(function (valueB, index) {});
              standard = mUtils.accAdd(standard, value.total);
              countTotal = mUtils.accAdd(countTotal, value.demandMoney);
              value.predictTotal = value.total;
              if (value.detailList.length > 1) {
                if (value.detailList[0].productName <= 5) {
                  value.productName =
                    value.detailList[0].productName +
                    "...等" +
                    value.detailList.length +
                    "款";
                } else {
                  value.productName =
                    value.detailList[0].productName.substring(0, 5) +
                    "...等" +
                    value.detailList.length +
                    "款";
                }
              } else {
                if (value.detailList[0].productName <= 5) {
                  value.productName =
                    value.detailList[0].productName +
                    "...等" +
                    value.detailList.length +
                    "款";
                } else {
                  value.productName =
                    value.detailList[0].productName.substring(0, 5) +
                    "...等" +
                    value.detailList.length +
                    "款";
                }
              }
            });
          }
          let obj = {};
          let arr = [];
          // orderName=res.data.data.vipCode+"-"+mUtils.formatDate( new Date(res.data.data.sendTime)).substring(0,10)
          obj.index = "VIP号：";
          obj.productName = res.data.data.vipCode;
          obj.expressNo = "客户：";
          obj.productSize = res.data.data.realName;
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = "#";
          obj.productName = "订单名";
          obj.expressNo = "运单号";
          obj.productSize = "体积 CBM";
          obj.productWeight = "重量 KG ";
          obj.rate = " 折扣率 %";
          obj.predictTotal = "费用 CAD ";
          obj.remark = "订单备注";
          arr.push(obj);

          res.data.data.list = arr.concat(res.data.data.list);
          arr = [];
          obj = {};
          obj.index = "总";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productSize = that.volumeTotal;
          obj.productWeight = that.weightTotal;
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productSize = "";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "标准费用";
          obj.remark = standard ? standard.toFixed(2) : 0;
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "工单费用";
          obj.remark = res.data.data.demandMoney || "0";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = true;
          obj.predictTotal = "额外费用";
          obj.remark = res.data.data.sendPojo.extraPrice || "0";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "额外费用备注";
          obj.remark = res.data.data.sendPojo.extraPriceRemark || "";
          that.feeInput = res.data.data.sendPojo.extraPrice || 0;
          that.textarea = res.data.data.sendPojo.extraPriceRemark || "";

          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = "发货单总费用";

          let newAmount = res.data.data.sendPojo.amount;
          obj.remark = newAmount ? newAmount.toFixed(2) : 0;
          arr.push(obj);

          // 测试写法 用于换行
          obj = {};
          obj.index = " ";
          obj.productName = " ";
          obj.expressNo = " ";
          obj.productVolume = " ";
          obj.productWeight = " ";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          obj = {};
          obj.index = "混箱数";
          obj.productName = res.data.data.mixingTankCount;
          // obj.productName = that.lookWhichRow.mixingTank;

          const MixTank = res.data.data.mixingTank;
          let mixBoxNumberStr = "";
          if (MixTank.length > 0) {
            MixTank.forEach((tank, index) => {
              mixBoxNumberStr += " " + tank.boxNumber;
            });
          }

          obj.expressNo = mixBoxNumberStr;
          obj.productVolume = " 123";
          obj.productSize = "";
          obj.productWeight = "";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          that.paramSendId = res.data.data.sendPojo.sendId;

          obj = {};
          obj.index = "箱数";
          // obj.productName = that.lookWhichRow.unMixingTank;
          obj.productName = res.data.data.unMixingTanksCount;

          const unMixTank = res.data.data.unMixingTanks;
          let unBoxNumberStr = "";
          unMixTank.forEach((unTank, index) => {
            unBoxNumberStr += " " + unTank.boxNumber;
          });

          obj.expressNo = unBoxNumberStr;
          obj.productVolume = " ";
          obj.productSize = "";
          obj.productWeight = "";
          obj.rate = " ";
          obj.predictTotal = " ";
          obj.remark = " ";
          arr.push(obj);

          res.data.data.list = res.data.data.list.concat(arr);

          that.tableData = res.data.data.list;
          if (that.toEcelce) {
            let columns = [
              { title: "#", key: "index" },
              { title: "订单名", key: "productName" },
              { title: "运单号", key: "expressNo" },
              { title: "体积 CBM", key: "productSize" },
              { title: "重量 KG ", key: "productWeight" },
              { title: "折扣率 %", key: "rate" },
              { title: "费用 CAD", key: "predictTotal" },
              { title: "订单备注", key: "remark" },
            ];

            mUtils.export2ExcelTitle(columns, that.tableData, that.orderTitle);
            that.toEcelce = false;
          }
        } else {
          that.$message.error("获取列表失败");
        }
        loading.close();
      });
    },

    updateExtraFee() {
      let that = this;
      that.isUpdateFeeShow = true;
    },
    closeUpdateDialog() {
      let that = this;
      that.isUpdateFeeShow = false;
    },
    certainUpdateDialog() {
      let that = this;

      if (that.feeInput == "") {
        that.$message.warning("额外费用不能为空");
        return;
      }

      let param = {
        sendId: that.paramSendId,
        extraPrice: that.feeInput,
        extraPriceRemark: that.textarea,
      };
      order.updateExtraInfo(param).then((res) => {
        if (res.data.code === 0) {
          that.$message.success("修改成功");
          that.getPreviewOrders(this.lookWhichRow);
        } else {
          that.$message.error("修改失败");
        }
        that.isUpdateFeeShow = false;
        that.feeInput = "";
        that.textarea = "";
      });
    },

    goodTypeName(goodType) {
      let str = "";
      switch (goodType) {
        case 1:
          str = "海运";
          break;
        case 2:
          str = "海运大件";
          break;
        case 3:
          str = "空运";
          break;
      }
      return str;
    },
    // 将时间戳转换为正常格式
    changeDate(row, type) {
      if (type == 1) return mUtils.formatDate(new Date(row.createTime), 4);
      else if (type == 2)
        return mUtils.formatDate(new Date(row.statementTime), 4);
      else if (type == 4) return mUtils.formatDate(new Date(row), 4);
    },
    async showEditDia(row) {
      this.deliveryId = row.deliveryId;
      this.sendNo = row.sendNo;
      this.status.statusType = row.status;
      this.isDisabledStatus = row.status;
      this.ruleForm.price = row.price;
      this.editLsit[0] = row;
      this.expectTime = "";
      if (row.expectTime) {
        this.expectTime = row.expectTime;
      }
      await this.getFeedbackList();
      this.editDialog = true;
    },
    showAccountDia(row) {
      this.ruleForm.price = row.price;
      this.sendId = row.sendId;
      let param = {
        sendId: row.sendId,
      };
      book.getSettlementSheet(param).then((res) => {
        if (res.status !== 200)
          return this.$message.error("获取出库面单失败:" + res.msg);
        if (res.data.code1 == 0)
          return this.$message.error("获取出库面单失败:" + res.data.msg);
        if (res.data.data.sendNo == null)
          return this.$message.error("获取出库面单失败:无出库面单数据");
        this.accountList[0] = res.data.data;
        this.listRow = this.accountList[0].orderPojoList
          ? this.accountList[0].orderPojoList
          : [];
        // this.accountDia = true;
        this.settlementBt();
      });
    },
    partList() {
      for (var i = 0; i < this.deliverList.length; i++) {
        if (this.deliverList[i].status == 0) {
          this.disposeList[this.disposeList.length] = this.deliverList[i];
        } else if (this.deliverList[i].status == 1) {
          this.disposingList[this.disposingList.length] = this.deliverList[i];
        } else if (this.deliverList[i].status == 2) {
          this.disposedList[this.disposedList.length] = this.deliverList[i];
        } else if (this.deliverList[i].status == -1) {
          this.cancelList[this.cancelList.length] = this.deliverList[i];
        }
      }
    },
    // 出库结算确定按钮
    settlementBt() {
      this.confirmSettlement();
      this.accountDia = false;
    },
    confirmSettlement() {
      let param = {
        sendId: this.sendId,
        balanceRemark: "预约派送结算",
        sign:1,
      };
      
      book.confirmSettlement(param).then((res) => {
        if (res.status !== 200)
          return this.$message.error("出库结算失败: " + res.data.msg);
        if (res.data.code !== 0) {
          return this.$message.error("出库结算失败: " + res.data.msg);
        }
        this.$message.success("出库结算成功");
        this.getDeliveryList();
      });
    },

    // 批量导出发货单
    exportToExcel() {
      let that = this;
      this.getHowMangTotal();
    },

    // 获得所有条数 需要导出的数据
    async getHowMangTotal() {
      let that = this;
      let param = {
        pageIndex: 1,
        pageSize: 400,
        orderNo: this.orderNo ? this.orderNo : "",
        userName: this.userName ? this.userName : "",
        deliveryNumber: this.deliveryNumber ? this.deliveryNumber : "",
        status: this.checkedStatus ? this.checkedStatus : "",
      };

      let howManyPage = Math.ceil((that.howManyTotal * 1) / 400);

      let listArr = [];

      for (let i = 1; i <= howManyPage; i++) {
        param.pageIndex = i;
        await book.getDeliveryList(param).then((res) => {
          if (res.data.code == 0) {
            if (res.data.data.list) {
              res.data.data.list.map((every, index) => {
                every.createTime = mUtils
                  .formatDate(new Date(every.createTime))
                  .substring(0, 19);

                if (every.goodType == 1) {
                  every.goodType = "海运";
                } else if (every.goodType == 2) {
                  every.goodType = "海运大件";
                } else if (every.goodType == 3) {
                  every.goodType = "空运";
                } else {
                  every.goodType = "";
                }

                if (every.status == 0) {
                  every.status = "待处理";
                } else if (every.status == 1) {
                  every.status = "处理中";
                } else if (every.status == -1) {
                  every.status = "已取消";
                } else if (every.status == 2) {
                  every.status = "已处理";
                } else {
                  every.status = "";
                }

                listArr.push(every);
              });

              // that.getAllData(res.data.data.pageCount);
            }
          }
        });
      }

      that.listArr = listArr;
      let orderName = "派送列表Excel";
      mUtils.export2Excel(that.columnsOrder, that.listArr, orderName);
    },

    // 每页多少条切换
    handleSizeChange(page_size) {
      let that = this;
      that.paginations.page_size = page_size;
      that.mainList.length = that.paginations.page_size * 1;
      if (that.res == undefined || that.res == "1") {
        that.checkedStatus = "";
      } else if (that.res == 2) {
        that.checkedStatus = "0";
      } else if (that.res == 3) {
        that.checkedStatus = "1";
      } else {
        that.checkedStatus = "2";
      }
      that.getDeliveryList();
    },
    // 上下分页
    handleCurrentChange(page) {
      let that = this;
      that.paginations.page_index = page;
      if (that.res == undefined || that.res == "1") {
        that.checkedStatus = "";
      } else if (that.res == 2) {
        that.checkedStatus = "0";
      } else if (that.res == 3) {
        that.checkedStatus = "1";
      } else {
        that.checkedStatus = "2";
      }
      that.getDeliveryList();
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    // 批量出库结算
    mulOutStoreToPay() {
      let that = this;
      if (
        that.multipleSelection == null ||
        that.multipleSelection.length == 0
      ) {
        this.$message.error("请选择");
        return;
      }
      let param = {};
      let sendIds = [];
      that.multipleSelection.forEach((obj) => {
        sendIds.push(obj.sendId);
      });
      param.sendIds = sendIds;
      param.balanceRemark = "预约派送结算";
      param.sign = 1;
      const loading = this.$loading({
        lock: true,
        text: "loading",
        spinner: "el-icon-loading",
        background: "rgba(0,0,0,0.7)",
      });

      book.mulOutStoreToPay(param).then((res) => {
        loading.close();
        if (res.data.code != 0) {
          return that.$message.error(res.data.msg || "操作异常");
        }
        that.$message({
          message: "提交成功!",
          type: "success",
        });
        that.getDeliveryList();
      });
    },

    // 获取批次列表
    getBatchList(value) {
      let that = this;

      let data = {};

      value ? (data.batchNumber = value) : "";

      order.getSelectBatchList(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            that.batchList = res.data.data;
          } else {
            that.batchList = [];
          }
        } else {
          that.$message.error("获取批次号列表失败");
        }
      });
    },

    // 清除所选批次
    clearChecked() {
      this.getBatchList();
      this.getDeliveryList();
    },

    batchChange() {
      this.getDeliveryList();
    },

    // 远程搜索批次
    remoteMethod(value) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.getBatchList(value);
      }, 500);
    },
  },
};
</script>

<style lang="less" scoped>
.warp_contrainer {
  padding: 3px 20px 50px 20px;
  margin-bottom: 50px;
}
.navCalss {
  font-family: "PingFangSC-Semibold", "PingFang SC Semibold", "PingFang SC",
    sans-serif;
  font-weight: 650;
  font-size: 18px;
}
.search {
  margin-top: 30px;
  font-size: 18px;
  min-width: 1000px;
  span {
    display: inline-block;
    margin-left: 20px;
    margin-top: 20px;
  }
}
.el-input {
  width: 220px;
}
.el-table {
  margin-top: 40px;
}
.warningText {
  margin-left: 15px;
  font-size: 18px;
}
.accountDia-footer {
  width: 100%;
  margin: auto;
  margin-top: 25px;
  text-align: center;
  letter-spacing: 50px;
  .el-button {
    width: 150px;
  }
}
.accountDia-content-header {
  position: relative;
  margin-top: -20px;
  width: 100%;
  overflow: hidden;

  .content-left {
    width: 36%;
    float: left;
  }
  .content-center {
    width: 36%;
    float: left;
  }
  .content-right {
    position: absolute;
    top: 0;
    right: 0;
    width: 20%;
  }
  .content-left-text {
    div {
      margin-bottom: 25px;
    }
  }
  div {
    margin-right: 20px;
  }
}
.footer {
  width: 100%;
  margin: 20px 0 50px 0;
  position: relative;
  .footer_pagination {
    position: absolute;
    right: 0;
    top: 0;
    left: 200px;
    margin-top: 0;
    text-align: right;
  }
}
.accountShop {
  width: 100%;
  overflow: hidden;
  border-bottom: 2px solid rgb(204, 202, 202);
  margin-bottom: 5px;
}
.accountShop-box {
  height: 48px;
  div {
    float: left;
  }
  .layout {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
  .box-index {
    margin-right: 1px;
    width: 5%;
    text-align: center;
  }
  .box-content {
    margin-right: 20px;
    width: 40.3%;
    position: relative;
    .content-account {
      margin-right: 10px;
      width: 18%;
    }
    .box-content-top {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 90%;
    }
    .content-weight {
      margin-right: 10px;
      width: 18%;
    }
    .content-length {
      width: 31%;
    }
    .content-warning {
      position: absolute;
      color: rgb(255, 39, 86);
      top: 15px;
      right: 35px;
    }
  }
  .box-transport {
    margin-right: 20px;
    width: 4.2%;
  }
  .box-img {
    margin-right: 30px;
    width: 5%;
  }
  .box-messages-left {
    margin-right: 15px;
    width: 16.5%;
  }
  .box-messages-right {
    width: 16.5%;
  }
}
.tag {
  display: inline-block;
  padding: 3px 5px;
  border-radius: 4px;
  background-color: #f4f4f5;
  border-color: #e9e9eb;
  color: #909399;
  &.tag1 {
    background-color: #ecf5ff;
    color: #409eff;
    border: 1px solid #d9ecff;
  }
  &.tag2 {
    background-color: #f0f9eb;
    border-color: #e1f3d8;
    color: #67c23a;
  }
  &.tag3 {
    background-color: #fdf6ec;
    border-color: #faecd8;
    color: #e6a23c;
  }
}
.diaBox{
  border: 2px solid black;
}
.diaBoxIn {
  box-sizing: border-box;
  width: 50%;
  float: left;
  // border: 1px solid;
}
.dialog_left {
  .dialog_left_top {
    div {
      font-size: 17px;
    }
  }
}
.dialog_left_center {
  p {
    font-size: 17px;
    span {
      font-size: 16px;
      color: red;
    }
  }
  .dialog_left_top2 {
    margin-top: 8px;
    font-size: 16px;
    span {
      font-size: 16px;
    }
    .rightSpan {
      display: inline-block;
      text-indent: 20px;
    }
  }
}
.dia_Text {
  height: 776px;
  .dia_Text_content {
    height: 90%;
    overflow: auto;
  }
}
.diaStyle {
  padding: 15px;
}
.dia_input {
  width: 150px;
}
.diaBox {
  overflow: hidden;
}
.dialog_right{
  box-sizing: border-box;
  border-left: 2px solid black;
}
.dialog_right_text {
  padding: 20px;
}
.dia_Text {
  position: relative;
  .dia_Text_input {
    width: 100%;
    position: absolute;
    bottom: 42px;
    left: 10px;
  }
  .dinput {
    width: 68%;
  }
  .dbt {
    width: 18%;
    .send{
      margin-left:-6px;
      display: inline-block;
      text-align: center;
    }
  }
}
.right_content {
  background-color: #eee;
}
.dia_Text_content {
  padding: 5px;
}
.accountShop {
  width: 100%;
  overflow: hidden;
  border-bottom: 2px solid rgb(204, 202, 202);
  margin-bottom: 5px;
}
.accountShop-box {
  height: 48px;
  div {
    float: left;
  }
  .layout {
    position: relative;
    top: 50%;
    transform: translateY(-50%);
  }
  .box-index {
    margin: 0 5px 0 50px;
    width: 5%;
    text-align: center;
  }
  .box-content {
    margin-right: 20px;
    width: 40.3%;
    position: relative;
    .box-content-top-out {
      max-width: 90%;
      .box-content-top {
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        background-color: #00bfff;
        border-radius: 3px;
        color: #fff;
      }
    }
    .content-account {
      margin-right: 10px;
      width: 18%;
    }
    .content-warning {
      position: absolute;
      color: rgb(255, 39, 86);
      top: 15px;
      right: 35px;
    }
  }
  .box-transport {
    margin-right: 40px;
    width: 4.2%;
  }
  .box-realName {
    margin: 6px 30px 0 0;
    max-width: 40%;
    background-color: #ffd700;
    border-radius: 5px;
    padding: 5px;
  }
  .box-messages-left {
    margin-right: 15px;
    width: 16.5%;
  }
  .box-messages-right {
    width: 16.5%;
  }
}
.e_text {
  margin-bottom: 10px;
  font-size: 18px;
}
.diaText {
  div {
    display: inline-block;
    margin-left: 12.5%;
  }
}
</style>


// WEBPACK FOOTER //
// deliveryList.vue?060f079a